import React, { SVGProps, forwardRef, Ref } from 'react';

type Props = {
  title?: React.ReactNode;
  titleId?: string;
} & SVGProps<SVGSVGElement>;

function SVGNovalearn(
  { title, titleId, ...props }: Props,
  svgRef?: Ref<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      viewBox="0 0 54 54"
      width="72"
      height="72"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <defs>
        <g />
        <clipPath id="fe7c5cb4a3">
          <path d="M 2 1 L 52 1 L 52 52 L 2 52 Z M 2 1 " clip-rule="nonzero" />
        </clipPath>
        <clipPath id="4e679e43e6">
          <path
            d="M 2.167969 5.335938 L 48.171875 1.675781 L 51.832031 47.683594 L 5.828125 51.34375 Z M 2.167969 5.335938 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="81c7cb540c">
          <path
            d="M 0.140625 0.648438 L 49.859375 0.648438 L 49.859375 50.367188 L 0.140625 50.367188 Z M 0.140625 0.648438 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="2c80c5c824">
          <path
            d="M 0.167969 4.335938 L 46.171875 0.675781 L 49.832031 46.683594 L 3.828125 50.34375 Z M 0.167969 4.335938 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="9f41f10910">
          <rect x="0" width="50" y="0" height="51" />
        </clipPath>
        <clipPath id="71aee4036d">
          <path d="M 12 0 L 43 0 L 43 53.019531 L 12 53.019531 Z M 12 0 " clip-rule="nonzero" />
        </clipPath>
        <clipPath id="6e77107ffe">
          <rect x="0" width="31" y="0" height="54" />
        </clipPath>
      </defs>
      <g clip-path="url(#fe7c5cb4a3)">
        <g clip-path="url(#4e679e43e6)">
          <g transform="matrix(1, 0, 0, 1, 2, 1)">
            <g clip-path="url(#9f41f10910)">
              <g clip-path="url(#81c7cb540c)">
                <g clip-path="url(#2c80c5c824)">
                  <path
                    fill="#e2001a"
                    d="M 0.167969 4.335938 L 46.171875 0.675781 L 49.832031 46.683594 L 3.828125 50.34375 Z M 0.167969 4.335938 "
                    fill-opacity="1"
                    fill-rule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clip-path="url(#71aee4036d)">
        <g transform="matrix(1, 0, 0, 1, 12, -0.000000000000014165)">
          <g clip-path="url(#6e77107ffe)">
            <g fill="#ffffff" fill-opacity="1">
              <g transform="translate(0.599446, 38.919966)">
                <g>
                  <path d="M 26.40625 0 L 19.875 0 L 8.921875 -16.578125 L 8.921875 0 L 2.375 0 L 2.375 -26.875 L 8.921875 -26.875 L 19.875 -10.21875 L 19.875 -26.875 L 26.40625 -26.875 Z M 26.40625 0 " />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default forwardRef(SVGNovalearn);
